import React from "react";
import "./WhyUs.css";
import whyImg from "./images/why-us1.webp";
import qualityIcon from "./images/quality.png";
import processIcon from "./images/process-new.png";
import teamIcon from "./images/team.png";
import speedIcon from "./images/speed.png";
import flexibleIcon from "./images/flexible.png";

const WhyUs = () => {
  const features = [
    {
      icon: qualityIcon,
      title: "100% Quality Guarantee",
      text: "Pay only after complete satisfaction.",
    },
    {
      icon: processIcon,
      title: <>Process <br />Driven</>,
      text: "Clear inspection & treatment workflow.",
    },
    {
      icon: teamIcon,
      title: "Trained Professionals",
      text: "Certified experts with modern methods.",
    },
    {
      icon: speedIcon,
      title: "Fast Response Time",
      text: "Quick scheduling with timely support.",
    },
    {
      icon: flexibleIcon,
      title: <> Flexible  <br />Solutions</>,
      text: "Tailored plans for every property type.",
    },
  ];

  return (
    <section className="why-us">
      <div className="why-head">
        <span className="why-badge">— Why Choose Us —</span>
        <h2>Trusted Protection. Proven Results.</h2>
      </div>

      <div className="why-banner">
        <img src={whyImg} alt="Why Choose Us" />
        <div className="why-dark-overlay"></div>

        <div className="why-circle-wrap">
          {features.map((item, index) => (
            <div className="why-circle" key={index}>
              <div className="circle-icon">
                <img src={item.icon} alt={item.title} loading="eager"
                  fetchPriority="high" />
              </div>
              <h4>{item.title}</h4>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;